import styled from 'styled-components';

export default function ViewerStockGauge({ current, initial }: { current: number; initial: number }) {
  const remaining = Number.isFinite(Number(current)) ? Math.max(0, Number(current)) : null;
  if (remaining === null || remaining >= 10) return null;
  const total = Number(initial);
  const ratio = remaining === 0 ? 0 : remaining !== null && total > 0 && Number.isFinite(total)
    ? Math.min(1, remaining / total) : null;
  const soldOut = remaining === 0;
  const lowStock = ratio !== null && ratio > 0 && ratio <= .2;
  return <Track role={ratio === null ? undefined : 'meter'} aria-label={ratio === null ? '재고 확인 중' : '남은 재고'}
      aria-valuemin={ratio === null ? undefined : 0} aria-valuemax={ratio === null ? undefined : 100}
      aria-valuenow={ratio === null ? undefined : Math.round(ratio * 100)}
      aria-valuetext={ratio === null ? undefined : `${remaining}개 남음${soldOut ? ', 품절' : ''}`}>
      {ratio !== null && <Fill $lowStock={lowStock} style={{ transform: `scaleX(${ratio})` }} />}
    </Track>;
}

const Track = styled.div`
  height: 5px;
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
  background: rgba(255,255,255,.18);
`;
const Fill = styled.div<{ $lowStock: boolean }>`
  width: 100%;
  height: 100%;
  border-radius: inherit;
  transform-origin: left;
  background: ${({ $lowStock }) => $lowStock ? 'linear-gradient(90deg, #fb7185, #fda4af)' : 'linear-gradient(90deg, #a78bfa, #f472b6)'};
  transition: transform 500ms ease-out;
  @media (prefers-reduced-motion: reduce) { transition: none; }
`;
